let tipo_doc = [
    { label: 'Constancia ARCA', value: '1' },
    { label: 'Constancia Ingresos Brutos', value: '2' },
    { label: 'Certificado de Retencion', value: '3' },
    { label: 'Certificado de Exencion', value: '4' },
    { label: 'Otro', value: '5' },
]
function toParams(params) {
    let ret = {}
    if (typeof params === 'object') {
        if ('primary' in params) {
            ret.namePrimary = params.primary.name || ''
            ret.label = params.primary.label || null
            ret.setup = {
                inputs: params.primary.inputs.map((x) => x.replace('*', '')),
                required: params.primary.inputs
                    .filter((x) => x.indexOf('*') !== -1)
                    .map((x) => x.replace('*', '')),
                type: params.primary.type || null,
            }
        }
        if ('secondary' in params) {
            ret.requiredSecondaryFiles = true
            ret.secondaryLabel = params.secondary.label || ''
            ret.nameSecondary = params.secondary.name || ''
            ret.secondarySetup = {
                inputs: params.secondary.inputs.map((x) => x.replace('*', '')),
                required: params.secondary.inputs
                    .filter((x) => x.indexOf('*') !== -1)
                    .map((x) => x.replace('*', '')),
                type: params.secondary.type || null,
            }
            ret.multi = params.secondary.multi || false
        }
    }
    return ret
}
let certExc = {
    label: 'Adjunte aqui sus certificados/documentacion adicional',
    type: '4',
    name: 'Certificado de Exencion - $jurisdiccion_name',
    inputs: ['fecha_emision*', 'fecha_vencimiento*', 'file*', 'jurisdiccion*'],
}
let primaryDoc = {
    label: 'Presentar Constancia o Resolución que acredite: ',
    type: '5',
    inputs: ['fecha_emision*', 'fecha_vencimiento*', 'file*'],
}
const soloPrincipal = (tdoc, name) => {
    return {
        label: `Presentar Constancia o Resolución que acredite: ${tdoc}`,
        name,
        inputs: ['file*'],
        type: '5',
    }
}
const completo = (tdoc, name) => {
    return {
        label: `Presentar Constancia o Resolución que acredite: ${tdoc}`,
        name,
        inputs: ['fecha_emision*', 'fecha_vencimiento*', 'file*'],
        type: '5',
    }
}
const exento = (tdoc, name) => {
    return {
        label: `Presentar Constancia o Resolución que acredite: ${tdoc}`,
        name,
        inputs: ['file'],
        type: '5',
    }
}
const fechaNoObligatoria = (tdoc, name) => {
    return {
        label: `Presentar Constancia o Resolución que acredite: ${tdoc}`,
        name,
        inputs: ['fecha_vencimiento', 'fecha_emision', 'file*'],
        type: '5',
    }
}
const soloPrincipalNoRequerido = (tdoc, name) => {
    return {
        label: `Presentar Constancia o Resolución que acredite: ${tdoc}`,
        name,
        inputs: ['file'],
        type: '5',
    }
}

export let impuestosJSON = {
    condicion_iva: {
        1: {
            primary: {
                label: 'Adjuntar documentacion respaldatoria que acredite: Responsable Inscripto',
                type: '5',
                name: 'Certificado de Responsable Inscripto',
                inputs: ['fecha_emision*', 'fecha_vencimiento*', 'file*'],
            },
            secondary: {
                ...certExc,
                label: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
                name: 'Presentar constancia o resolución que acredite exclusión o exención (IVA)',
                inputs: ['fecha_emision', 'fecha_vencimiento', 'file'],
            },
        },
        2: {
            primary: soloPrincipal('Monotributo', 'Certificado de Monotributo'),
        },
        4: {
            primary: {
                ...primaryDoc,
                label: primaryDoc.label + 'Exento (Opcional)',
                name: 'Certificado de Condicion Exento',
                inputs: ['file'],
            },
        },
        5: {
            primary: {
                label: 'Adjuntar documentacion respaldatoria que acredite: Sujeto comprendido en la R.G. 17/97 - 2226/07',
                type: '5',
                name: 'Certificado de Sujeto comprendido en la R.G. 17/97 - 2226/07',
                inputs: ['fecha_emision*', 'fecha_vencimiento*', 'file*'],
            },
        },
        6: {
            primary: {
                ...primaryDoc,
                label:
                    primaryDoc.label +
                    'Agente de retención (RG 18/97-2854/10) IVA',
                name: 'Constancia de Agente de retención (RG 18/97-2854/10) (IVA)',
                inputs: ['fecha_emision', 'fecha_vencimiento', 'file*'],
            },
        },
    },
    condicion_ganancias: {
        1: {
            primary: soloPrincipalNoRequerido(
                'Responsable Inscripto',
                'Certificado de Responsable Inscripto (Imp. Ganancias)'
            ),
            secondary: {
                ...certExc,
                label: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
                name: 'Certificado de Exencion Temporal',
                inputs: ['fecha_emision', 'fecha_vencimiento', 'file'],
            },
        },
        2: {
            primary: soloPrincipalNoRequerido(
                'Monotributo',
                'Certificado de Monotributo (Imp. Ganancias)'
            ),
        },
        4: {
            primary: fechaNoObligatoria(
                'Sujeto no pasible de retención',
                'Certificado Sujeto no pasible de retención (Imp. Ganancias)'
            ),
            secondary: {
                ...certExc,
                label: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
                name: 'Certificado de Exencion Temporal',
                inputs: ['fecha_emision', 'fecha_vencimiento', 'file'],
            },
        },
        5: {
            primary: completo(
                'Sujeto con autorización de no-retención',
                'Certificado de Sujeto con autorización de no-retención (Imp. Ganancias)'
            ),
            secondary: {
                ...certExc,
                label: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
                name: 'Certificado de Exencion Temporal',
                inputs: ['fecha_emision', 'fecha_vencimiento', 'file'],
            },
        },
        6: {
            primary: fechaNoObligatoria(
                'Exento',
                'Certificado de Exento (Imp. Ganancias)'
            ),
            secondary: {
                ...certExc,
                label: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
                name: 'Certificado de Exencion Temporal',
                inputs: ['fecha_emision', 'fecha_vencimiento', 'file'],
            },
        },
        7: {
            primary: completo(
                'Profesional organizado en forma de empresa (Anexo II RG 830/2000 inc. k)',
                'Certificado de Profesional organizado en forma de empresa (Anexo II RG 830/2000 inc. k) (Imp. Ganancias)'
            ),
            secondary: {
                ...certExc,
                label: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
                name: 'Certificado de Exencion Temporal',
                inputs: ['fecha_emision', 'fecha_vencimiento', 'file'],
            },
        },
        8: {
            primary: soloPrincipal(
                'Sociedades de hecho (incluidas Art. 53 inc b) y d) Ley de Impuesto a las ganancias',
                'Certificado Sociedad de Hecho (Imp. Ganancias)'
            ),
            secondary: {
                ...certExc,
                label: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
                name: 'Certificado de Exencion Temporal',
                inputs: ['fecha_emision', 'fecha_vencimiento', 'file'],
            },
        },
        9: {
            primary: soloPrincipal(
                'Sujeto con autorización de auto retención RG 830/2000',
                'Certificado de auto retención RG 830/2000 (Imp. Ganancias)'
            ),
            secondary: {
                ...certExc,
                label: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
                name: 'Certificado de Exencion Temporal',
                inputs: ['fecha_emision', 'fecha_vencimiento', 'file'],
            },
        },
    },
    condicion_iibb: {
        1: {
            primary: {
                ...completo(
                    'Contribuyente Local',
                    'Certificado de Contribuyente Local (IIBB)'
                ),
                type: '2',
            },
            secondary: {
                label: 'Agregar certificado de Exencion (IIBB)',
                name: 'Certificado de Exencion - $jurisdiccion_name (IIBB)',
                inputs: [
                    'jurisdiccion',
                    'fecha_emision',
                    'fecha_vencimiento',
                    'file',
                ],
                type: '4',
            },
        },
        2: {
            primary: {
                ...completo(
                    'Convenio Multilateral',
                    'Certificado de Convenio Multilateral (IIBB)'
                ),
                type: '2',
            },
            secondary: {
                label: 'Agregar certificado de Exencion (IIBB)',
                name: 'Certificado de Exencion - $jurisdiccion_name (IIBB)',
                inputs: [
                    'jurisdiccion*',
                    'fecha_emision*',
                    'fecha_vencimiento*',
                    'file*',
                ],
                type: '4',
                multi: true,
            },
        },
        3: {
            primary: {
                ...soloPrincipal(
                    'Régimen Simplificado',
                    'Constancia de Régimen Simplificado (IIBB)'
                ),
                type: '2',
            },
        },
        4: {
            primary: {
                ...exento(
                    'Exento de Imp. IIBB',
                    'Certificado de Excencion IIBB'
                ),
                type: '2',
            },
        },
        5: {
            primary: {
                ...fechaNoObligatoria(
                    'Agente de Retención',
                    'Certificado de Agente de Retención (IIBB)'
                ),
            },
            type: '2',
        },
        7: {
            primary: {
                ...completo(
                    'Sujeto no pasible de retención',
                    'Certificado de Sujeto no pasible de retención (IIBB)'
                ),
                type: '2',
            },
        },
    },
}
let certExc_ = {
    label: 'Adjunte aqui sus certificados/documentacion adicional',
    type: '4',
    // name: 'Certificado de Exencion - $jurisdiccion_name',
    inputs: ['fecha_emision*', 'fecha_vencimiento*', 'files*', 'jurisdiccion*'],
    optional: true,
    impuesto: '',
}
export let confImp = {
    condicion_iva: {
        1: {
            ...certExc_,
            title: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
            label: 'Presentar constancia o resolución que acredite exclusión o exención (IVA)',
            inputs: ['fecha_emision', 'fecha_vencimiento', 'files*'],
            impuesto: 'IVA',
        },
    },
    condicion_ganancias: {
        1: {
            ...certExc_,
            title: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
            label: 'Certificado de Exencion Temporal',
            inputs: ['fecha_emision', 'fecha_vencimiento', 'files*'],
            impuesto: 'Ganancias',
        },
        4: {
            ...certExc_,
            title: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
            label: 'Certificado de Exencion Temporal',
            inputs: ['fecha_emision', 'fecha_vencimiento', 'files*'],
            impuesto: 'Ganancias',
        },
        5: {
            ...certExc_,
            title: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
            label: 'Certificado de Exencion Temporal',
            inputs: ['fecha_emision', 'fecha_vencimiento', 'files*'],
            impuesto: 'Ganancias',
        },
        6: {
            ...certExc_,
            title: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
            label: 'Certificado de Exencion Temporal',
            inputs: ['fecha_emision', 'fecha_vencimiento', 'files*'],
            impuesto: 'Ganancias',
        },
        7: {
            ...certExc_,
            title: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
            label: 'Certificado de Exencion Temporal',
            inputs: ['fecha_emision', 'fecha_vencimiento', 'files*'],
            impuesto: 'Ganancias',
        },
        8: {
            ...certExc_,
            title: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
            label: 'Certificado de Exencion Temporal',
            inputs: ['fecha_emision', 'fecha_vencimiento', 'files*'],
            impuesto: 'Ganancias',
        },
        9: {
            ...certExc_,
            title: 'Presentar constancia o resolución que acredite exclusión o exención (Opcional)',
            label: 'Certificado de Exencion Temporal',
            inputs: ['fecha_emision', 'fecha_vencimiento', 'files*'],
            impuesto: 'Ganancias',
        },
    },
    condicion_iibb: {
        1: {
            title: 'Agregar certificado de Exencion (IIBB)',
            label: 'Certificado de Exencion - $jurisdiccion_name (IIBB)',
            inputs: [
                'jurisdiccion',
                'fecha_emision',
                'fecha_vencimiento',
                'files*',
            ],
            type: '4',
            impuesto: 'IIBB',
            optional: true,
        },
        2: {
            title: 'Agregar certificado de Exencion (IIBB)',
            label: 'Certificado de Exencion - $jurisdiccion_name (IIBB)',
            inputs: [
                'jurisdiccion*',
                'fecha_emision*',
                'fecha_vencimiento*',
                'files*',
            ],
            type: '4',
            impuesto: 'IIBB',
            optional: true,
            multi: true,
        },
    },
    general: [
        {
            title: 'Adjuntar Constancia de inscripcion ARCA',
            label: 'Constancia de inscripcion ARCA',
            type: '1',
            name: 'docu_cert_afip_ii',
            inputs: ['files*'],
            required: true,
        },
        {
            title: 'Adjuntar Constancia de inscripcion de Ingresos Brutos',
            label: 'Constancia de inscripcion de Ingresos Brutos',
            type: '2',
            name: 'docu_cert_iibb_ii',
            inputs: ['files*'],
            required: true,
        },
    ],
    otros: [
        {
            label: 'Otra documentación',
            title: '',
            inputs: [
                'fecha_emision',
                'fecha_vencimiento',
                'observacion*',
                'files*',
            ],
            multi: true,
            name: 'docu_otros_ii',
            impuesto: 'otros',
            optional: true,
        },
    ],
}
export const configImpuestos = Object.fromEntries(
    Object.keys(impuestosJSON).map((imp) => [
        imp,
        Object.fromEntries(
            Object.entries(impuestosJSON[imp]).map(([cod, conf]) => {
                return [cod, toParams(conf)]
            })
        ),
    ])
)
export const ENV = Object.fromEntries(
    Object.entries(import.meta.env).map(([k, v]) => {
        return [k.replace(/VITE_/g, ''), v]
    })
)
export const {
    CLOUDFLARE_SITEKEY,
    API_URL,
} = ENV
// export const CLOUDFLARE_SITEKEY = ENV.CLOUDFLARE_SITEKEY
// export const RECAPTCHA3_SITEKEY = ENV.RECAPTCHA3_SITEKEY
// export const RECAPTCHA2_SITEKEY = ENV.RECAPTCHA2_SITEKEY
// console.log(JSON.stringify(configImpuestos, null, 4));
